import type { BrandSpecial } from '@iheartjane/data-access';
import { CardCarousel, JaneGoldCard } from '@iheartjane/menu';
import { Flex, JaneGoldIcon, Typography } from '@iheartjane/reefer';

export interface BrandSpecialCardCarouselProps {
  authenticated?: boolean;
  brandSpecialCardTo?: (args: {
    brandId: string | number;
    brandName: string;
    brandSpecialId: string | number;
  }) => string;
  brandSpecials: BrandSpecial[];
  cardOnClick?: (
    brandSpecial: BrandSpecial,
    brandName: string,
    index: number
  ) => void;
  isLoading?: boolean;
  title?: string;
  viewAllTo?: string;
}

const CashBackRewards = ({
  title = 'Jane Gold rewards',
}: {
  title?: string;
}) => (
  <Flex alignItems="center">
    <JaneGoldIcon />
    <Typography ml={8} as="h2" branded variant="h2-semibold">
      {title}
    </Typography>
  </Flex>
);

export const BrandSpecialCardCarousel = ({
  authenticated,
  brandSpecialCardTo,
  brandSpecials,
  cardOnClick,
  isLoading,
  title,
  viewAllTo,
}: BrandSpecialCardCarouselProps) => {
  if (isLoading || brandSpecials.length > 0) {
    return (
      <CardCarousel
        cardGap={24}
        cardGapMobile={16}
        cardHeight={290}
        cardHeightMobile={260}
        cardWidth={350}
        cardWidthMobile={320}
        isLoading={isLoading}
        mode="ideal-width"
        my={24}
        name="Jane Gold rewards"
        beforeHeader={<CashBackRewards title={title} />}
        buttonTo={viewAllTo}
      >
        {brandSpecials.map((brandSpecial, index) => (
          <CardCarousel.Card key={`${brandSpecial.id}-${index}`}>
            <JaneGoldCard
              authenticated={authenticated}
              brandImage={brandSpecial.product_brand?.logo_url}
              brandName={brandSpecial.product_brand?.name}
              imageSrc={brandSpecial?.photo?.urls.original}
              isBundle={brandSpecial?.special_type !== 'product'}
              onClick={() =>
                cardOnClick?.(
                  brandSpecial,
                  brandSpecial.product_brand?.name,
                  index
                )
              }
              userSegments={brandSpecial}
              tagLabel={brandSpecial?.discount_label}
              title={brandSpecial?.title}
              to={brandSpecialCardTo?.({
                brandId: brandSpecial.product_brand_id,
                brandName: brandSpecial.product_brand?.name,
                brandSpecialId: brandSpecial.id,
              })}
            />
          </CardCarousel.Card>
        ))}
      </CardCarousel>
    );
  }

  return null;
};
